import React, { useState, useEffect,useContext } from 'react';
import '../styles/filing.css'
import { Link, useNavigate,useParams  } from 'react-router-dom';
import DynamicIcon from '../components/dynamicicon';
import Case_Search from '../components/core/case_search';
import { Search } from '@mui/icons-material';
import JisInput from '../components/controls/jisInput';
import JisInputView from '../components/controls/jisinputView';
import JisCheckbox from '../components/controls/jisCheckbox';
import JisButton from '../components/controls/jisButton';
import JisDropdown from '../components/controls/jisDropdown';
import FlowItem from '../components/controls/flowitem';
import { ShareContext } from '../context/ShareContext';

import * as Constants from '../constants';
import JisDialog from '../components/dialog';
import Gazette from '../components/core/gazette';
import BackLoader from '../components/backloader';
import Payment from '../components/core/payment';
import JisYesNo from '../components/controls/jisYesNo';
import JisParty from '../components/controls/jisparty';
import PdfViewer from '../components/controls/pdfviewer';
import MultiSelectDropdown from '../components/controls/multiselectdropdown';


function Filing_Case() {
    const navigate = useNavigate();
 const { caseid } = useParams();
 const FeeTYPEID=1;
    const {  activePage, token, profile, setIsExpired, setAlert,frequentData} = useContext(ShareContext);
    const [cinfo, setCase] =useState({stateId:Constants.Default_State,processType:'Normal',isPublic:1,
         caseFilingId:1,isDelarative:true,isRequireInterpretation :true,
    isLegalPolicy:true, isLegalPosition:true,isEmergency: true,isDispute : true, isUniform: true
     });
     
    const [flow, setFlow] = useState({pos:1, code:"case_details"});
    const [flowerror, setFlowError]=useState('');
    const [isSuccess, setIsSuccess]= useState(false);
    const [casetypes, setCasetypes]=useState([]);
    const [caseorigins, setCaseorigins] = useState([]);
    const [casecategories, setCasecategories] = useState([]);
    const [divisions, setDivisions] =useState([]);
    const [partytypes, setPartytypes]=useState([]);
    const [motiontypes, setMotiontypes]=useState([]);
    const [motionclass, setMotionclass]=useState([]);
    const [causeOfActions, setCauseOfActions]=useState([]);
    const [isVacation, setIsVacation] = useState(false);

    const [selectedCauses, setSelectedCauses] = useState([]);

    const [otherCauses, setOtherCauses] = useState([]);
    const [removingIndex, setRemovingIndex] = useState(null);
    const [casefees, setCaseFees] = useState([]); //this is the amount created to be sent to Pay4It 
    const [isFiat, setIsFiat]=useState(false);
    const [fiat, setFiat] = useState(null);
    const [fiatUrl, setFiatUrl] =useState('')
    const [isPreview, setIsPreview] = useState(false);
   
    const [states, setStates] =useState([]);
    const [Lga, setLga] = useState([]);
    const [cities, setCities] = useState([]);
 
    const [loading, setLoading] = useState(false);
    const [legal, setLegal]= useState({});
    const [showLegals, setShowLegals] = useState(false);
    const [claims, setClaims] = useState([{ claim:'',claimValue:'',currencyType:'' }]);
    const [parties,setParties] = useState([]);
    const [party, setParty] = useState({isOrg:0, isLeadParty:true, state:Constants.Default_State, partyTypeId:''});
    const [motions,setMotions] = useState([]);
    const [motion, setMotion] =useState([]);
    const [motionPrayers, setPrayers] = useState([{prayer:''}]);
    const [partyOptions, setPartyOptions] = useState([]);
    //const [isNew]


    const [locs, setLocs]=useState({state:null,lga:null,city:null})
    const [locs2, setLocs2]=useState({state:null,lga:null,city:null})
    const [isMotion,setIsMotion]= useState(false);
    const [isNewFiat, setNewFiat]=useState(true);
    const [casefeeId, setcasefeeId] = useState(null)

  const onSaveToLocal=()=>{
    var all={cinfo,selectedCauses,otherCauses,fiat,claims, parties, userid:profile.id}
    var str=JSON.stringify(all);
    localStorage.setItem('caseinfo',str);
  }

  const onDeleteFromLocal =() =>{
    localStorage.removeItem("caseinfo");
  }

    const processmode=[
        {label:'Normal',value:'Normal'},
        {label:'Fast Track', value:'Fast Track'},
        {label:'Urgency', value:'Urgency'}
    ]

    const partydes=[
        {label:'Individual', value:0},
        {label:'Organization',value:1},

    ]

    const idModes=[
        {label:'Passport',value:'Passport'},
        {label:'National ID', value:'National ID'},
        {label:'Driving Licence', value:'Driving Licence'},
        {label:'Others', value:'Others'}
    ]

 const caseidentity=[
        {label:'Public',value:1},
        {label:'Private', value:0},
    ]
   const currencies=[
        {label:'Naira (N)',value:"Naira" },
        {label:'Dollar ($)', value:"Dollar"},
        {label:'Euro (e)', value:"Euro"},
    ]  

    const onGotoDetails = () =>{
    setIsSuccess(false);
    navigate(`/document-upload/${casefeeId}`); //navigate to login

}
const on_case_details=(e)=>{
    e.preventDefault();
    onSaveToLocal();
if(isFiat && fiat==null){
     setFlowError('Please select the FIAT document for upload.')
        return
}
     if(!(selectedCauses.length>0 || otherCauses.length>0))
    {
        setFlowError('Please select one of the causes or enter other causes')
        return
    }
setFlowError('')
        //setFlow({pos:2,code:"options"});
         setFlow({pos:5,code:"parties"});
    }

   

  const on_claims=async(e)=>{
    e.preventDefault();
   
    const v=await onSave();

        setFlow({pos:7,code:"motions"});
    }
    const on_claims_back=()=> setFlow({pos:5,code:"parties"});

  const on_parties=async()=>{

    if(parties.length==0){
        setFlowError('You need to at lease one party to continue');
        return;
    }

    const hasLead=parties.find(r => r.isLeadParty)
    console.log(hasLead);
    if(!hasLead){
        setFlowError("Please indicate the lead party, by checking the Lead option");
        return;
    }
 
   setLoading(false);
    setFlowError("");
    //const v=await onSave();
    onSaveToLocal();
    setFlow({pos:6,code:"claims"});
   
    } 
    const on_parties_back=()=> setFlow({pos:1,code:"case_details"});
   const on_motions=async ()=>{

    if(isMotion && motions.length==0){
        setFlowError("Please file a motion or uncheck the question at the top.")
        return;
    }
    if( cinfo.processType=='vacation'){
      //check if motion with order 49 exist
        var order49= motions.find((d)=>d.motionTypeId==10);
        if(order49==null){
          setFlowError("for Vacation Type you must file Order 49")
        return;
        }
    }
    await onSave();
    //save motion on server
        setFlow({pos:8,code:"gazette"});
    }  
    const on_motions_back=()=> setFlow({pos:6,code:"claims"});

    const on_gazette=()=>{
        setFlow({pos:9,code:"payment"});
    } 
    const on_gazette_back=()=> setFlow({pos:7,code:"motions"});

const on_payment=()=>{
       //the final phase to external payment
    } 
    const on_payment_back=()=> setFlow({pos:8,code:"gazette"});

    useEffect(() => {
        var cc=localStorage.getItem("caseinfo");
        if(cc!=null){
        var all=JSON.parse(cc);
        //{cinfo,selectedCauses,otherCauses,fiat,claims}
            setCase(all.cinfo);
            setSelectedCauses(all.selectedCauses);
            setOtherCauses(all.otherCauses);
            setFiat(all.fiat);
            setClaims(all.claims);
            setParties(all.parties)
        }
    onLoad();
    if(caseid){
        onLoadCase(caseid);
    }
    onGetStates();

        
    }, [])
useEffect(() => {

setLegal({id:profile?.id, name: `${profile?.firstName} ${profile?.lastName??''}`})
    
}, [profile])

useEffect(() => {

setSelectedCauses([])
    
}, [cinfo.caseCategoryId])

useEffect(() => {

  if(cinfo?.referenceNumber==null){
   onSaveToLocal();
  }

    
}, [parties])

useEffect(() => {
    if(cinfo.stateId){
        onGetLgs(cinfo.stateId);
    }  
}, [cinfo.stateId])



useEffect(() => {
    if(cinfo.LocalGovtAreaId){
    onGetCities(cinfo.LocalGovtAreaId);
    }     
}, [cinfo.LocalGovtAreaId])





 const onGetStates= async()=>{
    //for account registration
    try {

      setLocs({...locs,state:false});
        const resp = await fetch(`${Constants.apiUrl}/profile/states`, { 
          method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': '',}, });  
        const data = await resp.json();
        setLocs({...locs,state:true});
       setStates(data); 
      } catch (error) {
        setLocs({...locs,lga:null});
        console.error(error);   
      }
}

useEffect(() => {
    if(cinfo.caseCategoryId){
    onGetCauseOfAction(cinfo.caseCategoryId)
    }     
}, [cinfo.caseCategoryId])

useEffect(() => {
   console.log('the use state fiat');
   console.log(fiat);    
}, [fiat])

const onGetCauseOfAction= async(id)=>{
    //for account registration
    try {

        const resp = await fetch(`${Constants.apiUrl}/filing/caause-of-action-by-cat/${id}`, { 
          method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': '',}, });  
        const data = await resp.json();
      
       setCauseOfActions(data); 
      } catch (error) {
        setLocs({...locs,lga:null});
        console.error(error);   
      }
}


const onLoad= async()=>{
    //for account registration
    try {
      setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/filing/new-case-dropdown`, { 
          method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization':  `Bearer ${token}`,}, });  
        const data = await resp.json();
        setLoading(false);
       // setCasetypes(data.casetype); 
      // setCaseorigins(data.caseorigin);
      // setCasecategories(data.casecategories)
      // setDivisions(data.divisions)
      // setPartytypes(data.partyTypes);
      // setMotionclass(data.motionclass);
      // setMotiontypes(data.motiontypes);
          setIsVacation(data.isVacation);
      } catch (error) {
        setLoading(false);
        console.error(error);   
      }
}

const onLoadCase= async(cid)=>{
    //for account registration
    try {
      setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/filing/case-filing/${cid}`, { 
          method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization':  `Bearer ${token}`,}, });  
        const data = await resp.json();
       setLoading(false);
        if(data.code==0){
            //caseinfo,parties, claims, causes
           var caseOptions={};
            if(data.caseinfo.caseOptions!=null){
              caseOptions=JSON.parse(data.caseinfo.caseOptions);
            }
             setCase({...data.caseinfo,...caseOptions});

            setParties(data.parties);
            setSelectedCauses(data.causes.filter(d=>d.causeId!=null));
            setOtherCauses(data.causes.filter(d=>d.causeId==null));
            setMotions(data.motions);
            if(data.fiat){
                setNewFiat(false);
                setIsFiat(true);
                setFiatUrl(Constants.AbsoluteFiletoRelative(data.fiat.doc) );
                console.log(Constants.AbsoluteFiletoRelative(data.fiat.doc));
                setFiat({...data.fiat,filename:"Fiat on Record"});
                console.log('set Fiat')
            }
            setClaims(data.claims);

            if(data.fee.length>0){
                    setcasefeeId(data.fee[0].id)
                }


                if(flow.pos==1){
                    if(data.fee.length>0){
                                //the payment part is the needed
                                setFlow({pos:9,code:"payment"});
                            }else if(data.motions.length>0){
                                //goto gazette part, it means it already have motion
                                setFlow({pos:8,code:"gazette"});
                            }
                            else{
                                //goto claims
                                    setFlow({pos:6,code:"claims"});
                            }
                    }   
        }
        else if(data.code==-10){
            setIsExpired(true);
        }

      } catch (error) {
        setLoading(false);
        console.error(error);   
      }
}

const onRemoveCause= async(id)=>{
    //for account registration
    try {
      setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/filing/remove-cause/${id}`, { 
          method: 'POST',  headers: {  'Content-Type': 'application/json','Authorization':  `Bearer ${token}`,}, });  
        const data = await resp.json();
       setLoading(false);
        if(data.code==0){
            //caseinfo,parties, claims, causes
           console.log(data);
        } else if(data.code==-10){
                      setIsExpired(true);
                  }

      } catch (error) {
        setLoading(false);
        console.error(error);   
      }
}

const onRemoveParty_Server= async(id)=>{
    //for account registration
    try {
      setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/filing/remove-party/${id}`, { 
          method: 'POST',  headers: {  'Content-Type': 'application/json','Authorization':  `Bearer ${token}`,}, });  
        const data = await resp.json();
       setLoading(false);
        if(data.code==0){
            //caseinfo,parties, claims, causes
           console.log(data);
        } else if(data.code==-10){
                      setIsExpired(true);
                  }

      } catch (error) {
        setLoading(false);
        console.error(error);   
      }
}
const onRemoveClaim_Server= async(id)=>{
    //for account registration
    try {
      setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/filing/remove-claim/${id}`, { 
          method: 'POST',  headers: {  'Content-Type': 'application/json','Authorization':  `Bearer ${token}`,}, });  
        const data = await resp.json();
       setLoading(false);
        if(data.code==0){
            //caseinfo,parties, claims, causes
           console.log(data);
        } else if(data.code==-10){
                      setIsExpired(true);
                  }

      } catch (error) {
        setLoading(false);
        console.error(error);   
      }
}

const onGetLgs= async(stateid)=>{
    //for account registration
    try {
        setLocs({...locs,lga:false});
        const resp = await fetch(`${Constants.apiUrl}/profile/lgs/${stateid}`, { 
          method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': '',}, });  
        const data = await resp.json();
       setLga(data);
        setLocs({...locs,lga:true});
       
      } catch (error) {
        setLocs({...locs,lga:null});
        console.error(error);   
      }
}

const onGetCities= async(lgid)=>{
    //for account registration
    try {
       setLocs({...locs,city:false});
       
        const resp = await fetch(`${Constants.apiUrl}/profile/cities/${lgid}`, { 
          method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': '',}, });  
        const data = await resp.json();
       setCities(data);
       setLocs({...locs,city:true});
       
      } catch (error) {
        setLocs({...locs,city:null});
        console.error(error);   
      }
}


 const onCaseChange = (e) => {
    setCase({...cinfo, [e.target.name]: e.target.value})
}


const onLegalChange =()=>{
        //see list of legal
        setShowLegals(true);
}



const onChangeOtherCause = (index, key, value) => {

  setOtherCauses(prev =>
    prev.map((item, i) => i === index ? { ...item, [key]: value } : item)
  );
};

const onRemoveOtherCause = async(index) => {
   
     setRemovingIndex(index);
     //check if object has an id
     const h=otherCauses[index];
     if(h.id>0){
        await onRemoveCause(h.id);
     }
  setTimeout(() => {
    setOtherCauses(prev => prev.filter((_, i) => i !== index));
    setRemovingIndex(null);
  }, 300); // match fadeOut duration

 
};

const onAddOtherCause = () => {
  setOtherCauses(prev => [...prev, {id:0, description:'',}]);
};

const onSaveParty=(e)=>{

     setFlowError('');
   var _party={...e, isOrg:party.isOrg=='1'?true:false}
    setParties(prev => [...prev, _party]);

}
const onRemoveParty =async (index) => {
   
    const h=parties[index];
        if(h && h.id>0){
            await onRemoveParty_Server(h.id);
        }
     setRemovingIndex(index);
  setTimeout(() => {
    setParties(prev => prev.filter((_, i) => i !== index));
    setRemovingIndex(null);
  }, 300); // match fadeOut duration

 
};

const onEditParty=(row,index) =>{
    setRemovingIndex(index);
  setTimeout(() => {
    setParties(prev => prev.filter((_, i) => i !== index));
    setRemovingIndex(null);
  }, 300); // match fadeOut duration

  //remove that one and allow it to be edited
      setParty(row);
  }

const onSave=async ()=>{
  /* const caseOptions ={isDelarative:cinfo.isDelarative,isRequireInterpretation :cinfo.isRequireInterpretation,
    isLegalPolicy:cinfo.isLegalPolicy, isLegalPosition: cinfo.isLegalPosition,isEmergency: cinfo.isEmergency,isDispute : cinfo.isDispute, isUniform: cinfo.isUniform} */

    const caseOptions ={isDelarative:cinfo.isDelarative,isRequireInterpretation :cinfo.isRequireInterpretation,
    isLegalPolicy:cinfo.isLegalPolicy, isLegalPosition: cinfo.isLegalPosition,isEmergency: cinfo.isEmergency,isDispute : cinfo.isDispute, isUniform: cinfo.isUniform
    }
    
    var caseFilingId=1;
console.log('the printed options');
console.log(caseOptions);
    const hasAnyFalse = Object.values(caseOptions).some(v => v === false);
    if (hasAnyFalse) {
        caseFilingId=2;
    console.log("At least one option is false. meanning its ADR");
    }
    var caseinfo={...cinfo,caseFilingId,caseOptions:JSON.stringify(caseOptions), isPublic:cinfo.isPublic=='1'?true:false};
    var _fiat=null;
    if( isNewFiat){
        var _fiat={doc:fiat?.base64,isPay:true};
    }
     //isPay is just to brng in file

    const stringObjects = otherCauses?.map(oc => ({
            id:oc.id,
            causedId: 0,
            description: oc.description}));

    //var _othercauses= otherCauses;
    var _causes= [...selectedCauses,...stringObjects];
    // claimstr: '', currency: '', value: ''
    var _claims=claims; //need to be inter prepreted as {claim,ClaimValue,CurrencyType}
    var casefiling={cinfo:caseinfo,fiat:_fiat,parties,causes:_causes
        ,claims,motions
    }

    //make sure the motion is order49
    

   setLoading(true)
        try {
          
          const resp = await fetch(`${Constants.apiUrl}/filing`, {
            method: 'POST',
            body:JSON.stringify(casefiling) ,
            headers: {
              'Content-Type': 'application/json, text/plain',
              Authorization: `Bearer ${token}`,
            },
          });
          
          const data = await resp.json();
          setLoading(false);

       //   setFlow({pos:6,code:"congrat"})
       localStorage.removeItem('caseinfo');
      
       if(data.code==0){
       // setIsSuccess(true);
       //process the flow and update the field.
       setCase({...cinfo,caseId:data.caseId, referenceNumber:data.referenceNumber});
        onDeleteFromLocal();
        setPartyOptions(data.partyOptions);
        onLoadCase(data.caseId); // to reload all the information with their respective ids
       } else if(data.code==-10){
                      setIsExpired(true);
                  }
       else{
        console.log(data);
        console.log(`the error received.`);
        setFlowError(data.satus)
       }
          
          
        } catch (error) {
          setLoading(false);
          console.error(error);
          setFlowError('cannot connect to the server at the moment. Try again')
         // onMove();
        }
}
const isCauseSelected = (id) => {
  return selectedCauses.some(item => item.causeId === id);
};
const onSelectedCause =async ({ opt, value }) => {
    setFlowError('')
    //check if on server
    if(!value){
        const h=selectedCauses.find(item=> item.causeId == opt.id);
        if(h && h.id>0){
            await onRemoveCause(h.id);
        }
    }
      

  setSelectedCauses(prev => {
    if (value) {
      // Add if not already present
      if (!prev.some(item => item.causeId === opt.id)) {
        return [...prev, { causeId: opt.id, description: opt.title }];
      }
      return prev;
    } else {
      // Remove
      
      return prev.filter(item => item.causeId !== opt.id);
    }
  });
};

const onChangeClaim = (index, key, value) => {
  setClaims(prev =>
    prev.map((item, i) => i === index ? { ...item, [key]: value } : item)
  );
};

const onRemoveClaims = async (index) => {
    if(claims.length==1){
        return;
    }

    const h=claims[index];
        if(h && h.id>0){
            await onRemoveClaim_Server(h.id);
        }
     setRemovingIndex(index);
  setTimeout(() => {
    setClaims(prev => prev.filter((_, i) => i !== index));
    setRemovingIndex(null);
  }, 300); // match fadeOut duration

 
};

const onAddClaim = () => {
  setClaims(prev => [...prev, { claim:'',claimValue:'',currencyType:''}]);
};


const onChangePrayer = (index, key, value) => {
  setPrayers(prev =>
    prev.map((item, i) => i === index ? { ...item, [key]: value } : item)
  );
};

const onRemovePrayer = async(index) => {
    if(motionPrayers.length==1){
        return;
    }
  const h=motionPrayers[index];
        if(h && h.id>0){
            await onRemovePrayer_Server(h.id);
        }
     setRemovingIndex(index);
  setTimeout(() => {
    setPrayers(prev => prev.filter((_, i) => i !== index));
    setRemovingIndex(null);
  }, 300); // match fadeOut duration

 
};
  const onRemovePrayer_Server= async(id)=>{
    //for account registration
    try {
      setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/filing/remove-prayer/${id}`, { 
          method: 'POST',  headers: {  'Content-Type': 'application/json','Authorization':  `Bearer ${token}`,}, });  
        const data = await resp.json();
       setLoading(false);
        if(data.code==0){
            //caseinfo,parties, claims, causes
           console.log(data);
        }
         else if(data.code==-10){
                      setIsExpired(true);
                  }

      } catch (error) {
        setLoading(false);
        console.error(error);   
      }
}

const onAddPrayer = () => {
  setPrayers(prev => [...prev, { prayer: '' }]);
};

const onMotionChange = (e) => {
    setMotion({...motion, [e.target.name]: e.target.value})
    
}
const onSaveMotion=(e)=>{
    e.preventDefault();
   // setParties({...parties,party});
    setMotions(prev => [...prev, {...motion,motionPrayers}]);
    setMotion({partyId:'',motionClassificationId:'',motionTypeId:''});
    setPrayers([{prayer:''}])
}

 const onRemoveMotion_Server= async(id)=>{
    //for account registration
    try {
      setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/filing/remove-motion/${id}`, { 
          method: 'POST',  headers: {  'Content-Type': 'application/json','Authorization':  `Bearer ${token}`,}, });  
        const data = await resp.json();
       setLoading(false);
        if(data.code==0){
            //caseinfo,parties, claims, causes
           console.log(data);
        } else if(data.code==-10){
                      setIsExpired(true);
                  }

      } catch (error) {
        setLoading(false);
        console.error(error);   
      }
}
const onRemoveMotion = async(index) => {
   
    const h=motionPrayers[index];
        if(h && h.id>0){
            await onRemoveMotion_Server(h.id);
        }
     setRemovingIndex(index);
  setTimeout(() => {
    setMotions(prev => prev.filter((_, i) => i !== index));
    setRemovingIndex(null);
  }, 300); // match fadeOut duration

 
};

const onEditMotion=(row,index) =>{
    setRemovingIndex(index);
  setTimeout(() => {
    setMotions(prev => prev.filter((_, i) => i !== index));
    setRemovingIndex(null);
  }, 300); // match fadeOut duration

  //remove that one and allow it to be edited
      setMotion(row);
      setPrayers(row.motionPrayers);
  }
    const onGazetteProceed=(e)=>{
        console.log('after processing... here is value')
        console.log(e);
        setcasefeeId(e.feeid);
        setIsSuccess(e.isPaid);
        if(!e.isPaid){
          on_gazette();
        }
        
    }

    
 const handleUploadChange =async (e  ) => {
       
        
        const files = e.target.files;
       setFiatUrl(URL.createObjectURL(files[0]))
        console.log('file document');
        console.log(files[0]);
        var b64=await Constants.toBase64(files[0]);

        var objUline={ doc:files[0], base64: b64.split(',')[1], filename:Constants.ReduceFilename(files[0]?.name), base64Ext:b64.split(',')[0],isPay:true }; //using isPay to indicate new fiat
        setFiat(objUline);
        setNewFiat(true);
        onPreview(objUline);

    };

const onPreview= async(id,uline)=>{
        const uploadurl=`${Constants.apiUrl}/gazette/uploadDocument/preview/${id}`
        

       // var updateditems=new Set(items);
            // Sending the FormData using fetch
            setLoading(true);
            fetch(uploadurl, {
            method: 'POST',
            body: JSON.stringify(uline),
            headers: {
              'Content-Type': 'application/json',
              'Authorization': '',
            },
            })
            .then(response => response.json())
            .then(data => {
                setLoading(false);
                console.log('preview details');
                console.log(data);
                if(data.code==0){
                    //saved already
                    var updated={...uline,prev:data}
                  
                    
                } else if(data.code==-10){
                      setIsExpired(true);
                  }
            })
            .catch(error => {
                console.error('Error:', error);
                setLoading(false);
        });
    }

  return (
    <div>
        <div style={{textAlign:'center'}}><h2>{cinfo?.caseTitle?.toUpperCase()}</h2>
        <h3>{cinfo.referenceNumber}</h3>
        </div>
      <div className='multiform'>
        <div  className='flow'>
        <div className='itemgroup'>
            <FlowItem flow={flow} pos={1} code="case_details" title="Case Details" />
            <FlowItem flow={flow} pos={5} code="parties" title="Parties" />
            <FlowItem flow={flow} pos={6} code="claims" title={cinfo.caseTypeId==2?"Offences":"Claims"} /> 
            <FlowItem flow={flow} pos={7} code="motions" title="Motions" />
            <FlowItem flow={flow} pos={8} code="gazette" title="Gazette" />
            <FlowItem flow={flow} pos={9} code="payment" title="Payment"  isLast={true} />
        </div>
        </div>
      {flow.code=='case_details' && <div className='view'>
        <form onSubmit={on_case_details}>
            <h2>FILING OF COURT PROCESS</h2>
        <div  className="input-group">
            <label>Parties to the Case  <span className="required">*</span> </label>
            <div className='input-wrapper'>
                <DynamicIcon iname="person_3" />
                <input placeholder='Parties to the Case' required={true} name="caseTitle" maxLength={300} value={cinfo.caseTitle?.toUpperCase()} onChange={onCaseChange}   />
            </div>
        </div>

        <div style={{display:'flex'}}>
            <div style={{flex:1}}> 
                <div  style={{display:'flex'}}>
                    
                <div className="select-group">
                  <label> Case Type <span className="required">*</span> </label>
                  <select name="caseTypeId" value={cinfo.caseTypeId} required={true} onChange={onCaseChange} >
                      <option value="">Select </option>
                      {frequentData?.casetype.map((opt) => (
                      <option key={opt.id} value={opt.id}>
                          {opt.caseType1}
                      </option>
                      ))}
                  </select>
                  </div>
                  <div className="select-group">
                  <label> Classification <span className="required">*</span> </label>
                  <select name="caseCategoryId" value={cinfo.caseCategoryId} required={true} onChange={onCaseChange} >
                      <option value="">Select </option>
                      {frequentData?.casecategories.filter(c => c.caseTypeId==cinfo.caseTypeId).map((opt) => (
                      <option key={opt.id} value={opt.id}>
                          {opt.categoryTitle}
                      </option>
                      ))}
                  </select>
                  </div>

                </div>
               
                <div style={{display:'flex'}}>
                  
                    <div className="select-group">
                            <label> Case Origin <span className="required">*</span> </label>
                            <select name="caseOriginId" value={cinfo.caseOriginId} required={true} onChange={onCaseChange} >
                                <option value="">Select </option>
                                {frequentData?.caseorigin.map((opt) => (
                                <option key={opt.id} value={opt.id}>
                                    {opt.title} {opt.id==3 && '(if this case was previously filed at Magistrate Court)'}
                                </option>
                                ))}
                            </select>
                            </div>
                  <div className="select-group">
                            <label> Mode of Process <span className="required">*</span> </label>
                            <select name="processType" value={cinfo.processType} required={true} onChange={onCaseChange} >
                               
                                {processmode.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                                ))}
                                {isVacation && <option value="vacation">Vacation</option>}
                            </select>
                            </div>          
                </div>
                <div  style={{display:'flex'}}>
                   {cinfo.caseOriginId==3 && <div  className="input-group">
                        <label>Magistrate Suit/Charge Number <span className="required">*</span> </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <input placeholder='Magistrate Suit/Charge Number' required={true} name="oldCaseNumber"  value={cinfo.oldCaseNumber} onChange={onCaseChange}   />
                        </div>
                    </div>} 
                    

                </div>
                <div style={{display:'flex'}}>
                    <JisCheckbox label="Check this box if this case is being filed by a religious body" value={cinfo.IsReligious} onChange={(e)=>setCase({...cinfo, IsReligious:e})} />
                   {cinfo.IsReligious && 
                   
                   <div className="select-group">
                            <label> Religion Group <span className="required">*</span> </label>
                            <select required={true} name="religiousGroup" maxLength={50} value={cinfo.religiousGroup} onChange={onCaseChange}  >
                                <option value="">Select </option>
                                <option>Christanity</option>
                                <option>Islam</option>
                                <option>Traditional</option>
                                <option>Others</option>
                            </select>
                            </div>
                   } 
                </div>
                {cinfo.IsReligious && <div  className="input-group">
                        <label>Religious Name <span className="required">*</span> </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <input placeholder='Religious Name' required={true} name="religiousName" maxLength={50} value={cinfo.religiousName} onChange={onCaseChange}   />
                        </div>
                    </div>} 
                   
                    
                <div  style={{display:'flex'}}>
                    <JisCheckbox label="Check this box if you have FIAT  to this case" value={isFiat} onChange={(e)=>setIsFiat(e)} />
                    {isFiat && <div className="btn-upload" >
                                                <input type="file" name="fiatdoc" accept="application/pdf" id={`file-fiat`} 
                                                onChange={(e) => handleUploadChange(e)}/>
                                                <label htmlFor={`file-fiat`} title={fiat?.name}>{fiat==null?'Click to upload FIAT document': Constants.ReduceString(fiat?.filename, 30)  }</label>
                                              {fiat!=null && <JisButton onClick={()=>setIsPreview(true)} icon='preview'>Preview Fiat Document</JisButton>} 
                                             {fiat==null && <div style={{color:'red'}}>*</div> } 
                                            </div>}    
                </div>        

            </div>
           
        </div>
        <div style={{display:'flex'}}>
            <div style={{flex:1}}>
                <div  style={{display:'flex'}}>
                    <div  className="input-group">
                        <label>Number of Witnesses  <span className="required">*</span> </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <input placeholder='Number of Witnesses' required={true} name="witness" type='number' value={cinfo.witness} onChange={onCaseChange}   />
                        </div>
                    </div>
                    <div className="select-group">
                            <label> Division <span className="required">*</span> </label>
                            <select name="divisionId" value={cinfo.divisionId} required={true} onChange={onCaseChange} >
                                <option value="">Select </option>
                                {frequentData?.divisions.map((opt) => (
                                <option key={opt.id} value={opt.id}>
                                    {opt.title}
                                </option>
                                ))}
                            </select>
                            </div>
                 <div className="select-group">
                            <label> Case Identity <span className="required">*</span> </label>
                            <select name="isPublic" value={cinfo.isPublic} required={true} onChange={onCaseChange} >
                               
                                {caseidentity.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                                ))}
                            </select>
                            </div>        
                </div>

               {profile.isLawFirm && <div style={{display:'flex'}}>
                    
                        <div className="input-group">
                            <label> Legal Counsel<span className="required">*</span></label>
                            <div className='input-wrapper'>
                                <DynamicIcon iname="balance" />
                              <input placeholder='Legal Counsel'  disabled  value={legal.name}    /> 
                            </div>
                        </div>
                        <div style={{justifyContent:'end'}}>
                           <JisButton  icon={'balance'} onClick={onLegalChange} >Change Legal Counsel</JisButton>
                        </div>
                  

                </div>} 

                <div style={{display:'flex'}}>
                         <div className="select-group">
                            <label> State <span className="required">*</span></label>
                            <select name="stateId" required={true} value={cinfo.stateId} onChange={onCaseChange} >
                               {locs.state==null  && <option value="">Select state</option>}
                                {locs.state==false && <option value="">loading state</option>}
                                {locs.state  && <option value="">Select state</option>}

                                {states.map((opt) => (
                                <option key={opt.id} value={opt.id}>
                                    {opt.title}
                                </option>
                                ))}
                            </select>
                            </div>
                        <div className="select-group">
                            <label> L.G.A <span className="required">*</span></label>
                            <select  name="LocalGovtAreaId" value={cinfo.LocalGovtAreaId} required={true} onChange={onCaseChange}>
                                {locs.lga==null  && <option value="">Select State first</option>}
                                {locs.lga==false && <option value="">loading LG</option>}
                                {locs.lga  && <option value="">Select LG</option>}


                                {Lga.map((opt) => (
                                <option key={opt.id} value={opt.id}>
                                    {opt.title}
                                </option>
                                ))}
                            </select>
                            </div>
                       <div className="select-group">
                            <label> City <span className="required">*</span></label>
                            <select  name="cityId" value={cinfo.cityId} required={true} onChange={onCaseChange}>
                                {locs.city==null  && <option value="">Select LGA first</option>}
                                {locs.city==false && <option value="">loading cities</option>}
                                {locs.city && <option value="">Select city</option>}
                                {cities.map((opt) => (
                                <option key={opt.id} value={opt.id}>
                                    {opt.title}
                                </option>
                                ))}
                            </select>
                            </div>
                    </div> 
                <div>
                   

                
                </div>
            </div>
          
        </div>
 <div style={{ margin:'auto'}}>
            <div>
                <h2>Select Option(s)</h2>
                <p>Check the option(s) applicable from below: </p>
            </div>
            



            <div style={{display:'flex', marginBottom:18, marginTop:18}}>
                 <JisYesNo  label="Is Declarative Order Sought?" value={cinfo.isDelarative} onChange={(e)=> setCase({...cinfo, isDelarative:e})}/>   

                <JisYesNo label="Does the case require Legal Interpretation?" value={cinfo.isRequireInterpretation} onChange={(e)=> setCase({...cinfo, isRequireInterpretation:e})} />
            </div>
            <div style={{display:'flex', marginBottom:18}}>
                <JisYesNo label="Is legal policy or constitutional issues that necessitate a binding and public precedent involved?" 
                value={cinfo.isLegalPolicy} onChange={(e)=> setCase({...cinfo, isLegalPolicy:e})} />
                <JisYesNo label="Is declaration of the legal position or interpretation of an instrument or policy document involved?"
                 value={cinfo.isLegalPosition} onChange={(e)=> setCase({...cinfo, isLegalPosition:e})} />
            </div>
            <div style={{display:'flex', marginBottom:18}}>
                <JisYesNo label="Is emergency injunctive relief sought or party needed to maintain status quo?"
                 value={cinfo.isEmergency} onChange={(e)=> setCase({...cinfo, isEmergency:e})} />
                <JisYesNo label="Does the dispute significantly affect non-parties?" 
                value={cinfo.isDispute} onChange={(e)=> setCase({...cinfo, isDispute:e})} />
            </div>
            <div style={{display:'flex', marginBottom:18}}>
                <JisYesNo label="Is there a need for uniform treatment towards an issue or disputant?" 
                value={cinfo.isUniform} onChange={(e)=> setCase({...cinfo, isUniform:e})}/>
                
            </div>
           
            
            </div> 

 
        <div>
             <h2>Cause Of Action</h2>
             <div style={{display:'flex', flexDirection:'row'}}>
                    <div style={{flex:1}}>

      <MultiSelectDropdown
        options={causeOfActions}
        placeholder="Select cause(s) of action"
        onChange={setSelectedCauses}
      />                      
                    </div>
                    <div style={{flex:1}}>
                        <p>For additional cause of action not listed, please click the "Add other Causes" button below:</p>
 {otherCauses?.map((opt, index) => (
                    <div key={index} className={`cause-item ${removingIndex === index ? 'removing' : ''}`}>
                        <div className="input-group">
                        <label>
                            Other Cause Of Action {index + 1} <span className="required">*</span>
                        </label>
                        <div className="input-wrapper">
                            <DynamicIcon iname="group" />
                            <input
                            placeholder="Enter Cause of Action"
                            required
                            value={opt.description}
                            onChange={(e) => onChangeOtherCause(index, 'description', e.target.value)}
                            />
                        </div>
                        </div>
                        <div onClick={() => onRemoveOtherCause(index)} className='delete'>
                        <DynamicIcon iname="trash-2" /> Delete
                        </div>
                    </div>
                    ))}
                  <JisButton icon="add" onClick={onAddOtherCause}>Add Other Causes</JisButton>   
                    </div>
             </div>
        

               
               
               
<div className='flowerror'>{flowerror}</div>
        </div>
         <div className='flowbuttongroup'>
             <JisButton type='submit'>Proceed</JisButton>
         </div>
        </form>
        
        </div>} 
       
  

      {flow.code=='claims' &&  <div className='view'>
        <form onSubmit={on_claims}>
            {claims.map((claim, index) => (
            <div key={index} className={`claim-item ${removingIndex === index ? 'removing' : ''}`}>
                <div style={{ flex: 1 }}>
                
                <div  className="input-group">
                        <label> {cinfo.caseTypeId == 2 ? 'Offences' : 'Claims'} <span className="required">*</span> </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <textarea placeholder='e.g Money Laundering' required={true}  value={claim.claim}
                    onChange={(e) => onChangeClaim(index, 'claim', e.target.value)}   />
                        </div>
                    </div>

              {cinfo.caseTypeId != 2 && <div style={{ display: 'flex', gap: 8 }}>
                    
                    <div className="select-group">
                        <label>
                            Currency Type 
                        </label>
                        <select name="gender"  value={claim.currencyType}
                    onChange={(e) => onChangeClaim(index, 'currencyType', e.target.value)} >
                            <option value="">Select </option>
                            {currencies.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                                {opt.label}
                            </option>
                            ))}
                        </select>
                    </div>

                    <div  className="input-group">
                        <label> Claim Value (Numbers only) </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="money" />
                            <input required={claim.currency}  placeholder="eg 300" 
                            value={Constants.formatCurrency(claim.claimValue) }
                             onChange={(e) => onChangeClaim(index, 'claimValue', e.target.value)}  />
                        </div>
                    </div>
                  
                </div>}  
                </div>
                <div  onClick={() => onRemoveClaims(index)} className='delete'>
                <DynamicIcon iname="trash-2"/> Delete
                </div>
            </div>
        ))}
            <JisButton icon="add" onClick={onAddClaim}>Add {cinfo.caseTypeId == 2 ? 'Offence' : 'Claim'}</JisButton>

         <div className='flowbuttongroup'>
                        <JisButton variant='outline' onClick={on_claims_back}>Back</JisButton>
                        <JisButton type='submit' loading={loading}>Proceed</JisButton>
                    </div> 
        </form>
       
        </div>} 
     
      {flow.code=='parties' && <div className='view'>
        <h2>Add Parties to the case</h2>
        <span style={{color:'red', fontWeight:'bold'}}>Select at least one party as the lead party ***</span>
        
            <JisParty onSave={onSaveParty} defaultParty={party} />
     
          {parties.length> 0 && 
          <div className='table'>
            <div class="section-cases">
              <span>Parties to the case</span><span className='total'>{parties.length}</span>
            </div>
              <table  class="case-table">
            <tr>
                <th>Name</th>
                <th>Party Type</th>
                <th>Phone Number</th>
                <th>Email</th>
                <th>Lead</th>
                <th>Address</th> 
                <th>Action</th>
            </tr>
            {parties?.map((opt,index) => (
                <tr key={index}>
                    <td>{`${opt.firstName} ${opt.lastName??''}`}</td>
                    <td>{Constants.getItemById(frequentData?.partyTypes,opt.partyTypeId)?.title} </td>
                    <td>{opt.primaryContactNumber}</td>
                    <td>{opt.primaryEmail}</td>
                    <td>{opt.isLeadParty?'Yes':'No'}</td>
                    <td>{opt.address1}</td>
                    <td>
                     <div className='groupbtn'>
                       <JisButton  variant='plain' icon="edit" onClick={()=>onEditParty(opt,index)}>Edit</JisButton> 
                    <JisButton variant='plain' icon="trash-2" onClick={()=>onRemoveParty(index)}>Remove</JisButton>
                      </div></td>
                </tr>
                                
                                ))}
            </table>   
            </div>}  
          
           <div className='flowerror'>{flowerror}</div>                    
         <div className='flowbuttongroup'>
                        <JisButton variant='outline' onClick={on_parties_back}>Back</JisButton>
                        <JisButton  onClick={on_parties} >Proceed</JisButton>
                    </div>
        </div>}  
      {flow.code=='motions' &&  <div className='view'>
        <div>
            <h2>Motion Filing to the case </h2>
        <JisCheckbox value={isMotion} label="I am filing motion to this case" onChange={(e)=>setIsMotion(e)}/>
        </div>
      {(isMotion || cinfo.processType=='vacation') && <div>
        <form onSubmit={onSaveMotion}>
            <div>
                                <div className="select-group">
                                            <label>Select Party </label>
                                                    <select name="partyId" value={motion.partyId} required onChange={onMotionChange} >
                                                        <option value="">Select </option>
                                                        {partyOptions
                                                            //?.filter(opt => opt.partyTypeId == Constants.ClaimantType)
                                                            .map((opt, index) => (
                                                                <option key={index} value={opt.id}>
                                                                {opt.firstName} {opt.lastName??''}
                                                                </option>
                                                            ))}
                                                                                                                
                                                            
                                                            </select>
                                            </div>
                                <div style={{display:'flex'}}>
                                    <div className="select-group">
                                            <label> Motion/Application classification </label>
                                                    <select name="motionClassificationId" value={motion.motionClassificationId} required onChange={onMotionChange} >
                                                        <option value="">Select </option>
                                                        {frequentData?.motionclass?.map((opt) => (
                                                        <option key={opt.id} value={opt.id}>
                                                            {opt.title}
                                                        </option>
                                                        ))}
                                                    </select>
                                            </div>
                                    <div className="select-group">
                                            <label> Motion/Application Type  </label>
                                                    <select name="motionTypeId" value={motion.motionTypeId} required  onChange={onMotionChange} >
                                                        <option value="">Select </option>
                                                        {frequentData?.motiontypes?.filter((e)=>e.filingTypeId==1).map((opt) => (
                                                        <option key={opt.id} value={opt.id}>
                                                            {opt.title}
                                                        </option>
                                                        ))}
                                                    </select>
                                            </div>        
                                </div>
                                <div>
                                    {motionPrayers?.map((pray, index) => (
                                <div key={index} className={`claim-item ${removingIndex === index ? 'removing' : ''}`}>
                                    <div style={{ flex: 1 }}>
                                    
                                    <div  className="input-group">
                                            <label>Particulars of Prayers Sought <span className="required">*</span> </label>
                                            <div className='input-wrapper'>
                                                <DynamicIcon iname="group" />
                                                <textarea placeholder=' Particulars of Prayers Sought' required={true}  value={pray.prayer}
                                        onChange={(e) => onChangePrayer(index, 'prayer', e.target.value)}   />
                                            </div>
                                        </div>
                    
                                    </div>
                                    <div className='delete' onClick={() => onRemovePrayer(index)}>
                                    <DynamicIcon iname="trash-2" /> <span>Delete</span>
                                    </div>
                                </div>
                            ))}
                                <JisButton icon="add" onClick={onAddPrayer}>Add Prayer</JisButton>

                                    </div>

                                    <div style={{marginTop:16}}>
                                        <JisButton icon="add" type='submit'>Save Motion</JisButton>
                                    </div>
                            </div>
        </form>
            
                {motions.length> 0 && 
                <div className='table-div'>
                    <table>
                    <tr>
                        <th>Party</th>
                        <th>Application Classification</th>
                        <th>Application Type</th>
                        <th>Prayers</th>
                        <th>Action</th>
                    </tr>
                    {motions?.map((opt,index) => (
                        <tr key={index}>
                            <td>{Constants.getItemById(partyOptions,opt.partyId)?.firstName} {Constants.getItemById(partyOptions,opt.partyId)?.lastName??''}</td>
                            <td>{Constants.getItemById(frequentData?.motionclass,opt.motionClassificationId)?.title}</td>
                            <td>{Constants.getItemById(frequentData?.motiontypes,opt.motionTypeId)?.title}</td>
                            <td>
                                <ol>
                                    {opt.motionPrayers?.map((pray,ind) => (
                                        <li key={ind}>{pray.prayer}</li>
                                    ))}
                                </ol>
                            </td>
                        
                            <td><JisButton icon="edit" onClick={()=>onEditMotion(opt,index)}>Edit</JisButton> 
                            <JisButton icon="close" onClick={()=>onRemoveMotion(index)}>Remove</JisButton></td>
                        </tr>
                                        
                                        ))}
                    </table>   
                    </div>}  
        </div>}  
        
<div className='flowerror'>{flowerror}</div>
         <div className='flowbuttongroup'>
                        <JisButton variant='outline' onClick={on_motions_back}>Back</JisButton>
                        <JisButton type='submit' onClick={on_motions}>Proceed</JisButton>
                    </div>
        </div>} 
      {flow.code=='gazette' &&  <div className='view'>
        <Gazette filingtypeid={cinfo.caseFilingId} levelid={cinfo.caseCategoryId} feetypeid={FeeTYPEID}
        token={token} onProceed={(e)=>onGazetteProceed(e)} caseid={cinfo.caseId} feeId={casefeeId}>
             <div className="top-nav">
                <div className="left-top">
                    <div className="top">
                        <h2 style={{color:'var(--primary)'}}>{cinfo?.referenceNumber} | {Constants.getItemById(frequentData?.casecategories,cinfo.caseCategoryId)?.categoryTitle}</h2>
                        
                    </div>
                    <p>Select items related to the case that you are filing</p>
                </div>
                <p className="nav-status">Suit Filing /Specifications</p>
            </div>
        </Gazette>

         <div className='flowbuttongroup'>
                        <JisButton onClick={on_gazette_back}>Back</JisButton>
                       {/*  <JisButton type='submit' onClick={on_gazette}>Proceed</JisButton> */}
                    </div>
        </div>} 
      {flow.code=='payment' && <div className='view'>

        <Payment feeid={casefeeId} token={token} />
        
         <div className='flowbuttongroup'>
                        <JisButton onClick={on_payment_back}>Back</JisButton>
                       
                    </div>
        </div>}  
      </div>
    {showLegals && <JisDialog>
        <div>List all available arthoney attached to the Firm</div>

      </JisDialog>} 

      {isSuccess && <JisDialog title="Case Created Successfully.">
        <div>This case is created successfully.  Payment is not required. Please continue to upload document</div>
            <JisButton onClick={onGotoDetails} >Upload document</JisButton>
      </JisDialog>} 

      {isPreview && <div className={  "preview open" } style={{overflow:'scroll'}}>
                <div className="heading">
                  <div>
                    <JisButton icon="close"  onClick={() => setIsPreview(false)}> Close Preview</JisButton>
                     </div>
                  
                </div>
               <PdfViewer   pdfUrl={fiatUrl}/>
               
                
                <div className="date-btns">
                    
                  
                </div>
            </div>} 

           <BackLoader open={loading} />
    </div>
  );
}

export default Filing_Case;